import { FieldValues } from 'react-hook-form';
import PhoneInput, { PhoneInputProps } from '../../library/PhoneInput';
import {
  usePhoneFieldController,
  UsePhoneFieldControllerProps,
} from '../../../hooks/form/usePhoneFieldController';
import ErrorMessage from '../shared/ErrorMessage';

type PhoneInputPropsWithControllerProps<TFieldValues> =
  UsePhoneFieldControllerProps<TFieldValues> &
    Omit<
      PhoneInputProps,
      | 'name'
      | 'value'
      | 'defaultValue'
      | 'disabled'
      | 'onChange'
      | 'onBlur'
      | 'required'
      | 'error'
    >;

export interface PhoneFieldProps<TFieldValues>
  extends PhoneInputPropsWithControllerProps<TFieldValues> {}

export default function PhoneField<TFieldValues extends FieldValues>(
  props: PhoneFieldProps<TFieldValues>,
) {
  const {
    name,
    onChange,
    onBlur,
    helperText,
    defaultValue,
    rules,
    shouldUnregister,
    disabled,
    mobile,
    ...restPhoneFieldProps
  } = props;

  const {
    field,
    required,
    onBlurField,
    onChangeField,
    formState: { errors },
    fieldState: { invalid: error },
  } = usePhoneFieldController<TFieldValues>({
    name,
    onChange,
    onBlur,
    defaultValue,
    rules,
    shouldUnregister,
    disabled,
    mobile,
  });

  return (
    <PhoneInput
      name={field.name}
      value={field.value}
      disabled={field.disabled}
      inputRef={field.ref}
      onChange={onChangeField}
      onBlur={onBlurField}
      error={error}
      helperText={
        error ? <ErrorMessage name={field.name} errors={errors} /> : helperText
      }
      required={required}
      disableDialCodePrefill={!required}
      {...restPhoneFieldProps}
    />
  );
}
